/**
 * GraphQL Mutations for User Profile service
 */

export const CREATE_CONTACT = `
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      id
      userId
      typeId
      rank
      contactValue {
        ... on ScalarContact { val }
        ... on AddressContact { building unit streetNumber streetName locality region postcode country formattedAddress }
      }
      isActive
      isRecovery
      createdAt
    }
  }
`;

export const UPDATE_CONTACT = `
  mutation UpdateContact($id: ID!, $input: UpdateContactInput!) {
    updateContact(id: $id, input: $input) {
      id
      userId
      typeId
      rank
      contactValue {
        ... on ScalarContact { val }
        ... on AddressContact { building unit streetNumber streetName locality region postcode country formattedAddress }
      }
      isActive
      isRecovery
      updatedAt
    }
  }
`;

export const DELETE_CONTACT = `
  mutation DeleteContact($id: ID!) {
    deleteContact(id: $id)
  }
`;

export const SET_PRIMARY_CONTACT = `
  mutation SetPrimaryContact($id: ID!) {
    setPrimaryContact(id: $id) {
      id
      rank
    }
  }
`;

export const BOUNCE_CONTACT = `
  mutation BounceContact($id: ID!) {
    bounceContact(id: $id) {
      id
      bounced
      bounceCount
      lastBounced
    }
  }
`;

export const UNBOUNCE_CONTACT = `
  mutation UnbounceContact($id: ID!) {
    unbounceContact(id: $id) {
      id
      bounced
      bounceCount
      lastBounced
    }
  }
`;

export const REORDER_CONTACTS = `
  mutation ReorderContacts($input: ReorderContactsInput!) {
    reorderContacts(input: $input) {
      id
      rank
    }
  }
`;

export const UPDATE_USER_PROFILE = `
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      id
      firstName
      lastName
      fullName
      gender
      birthDate
      isActive
    }
  }
`;
